import type { ProductEnvironment } from '@atlassian/forge-ui-types/environments';

import { urlSafeB64 } from '../custom-ui/iframe/utils/createSrcFromExtension';
import { getEncodedAppContext } from '../custom-ui/iframe/utils/getEncodedAppContext';
import { getForgeCDNBaseDomain } from '../utils';
import type { GQLExtension } from '../web-client/graphql/types';

export const getForgeSandboxOrigin = (environment: ProductEnvironment): string => {
	return `https://forge.${getForgeCDNBaseDomain(environment)}`;
};

export const getForgeRuntimeSandboxSrc = (environment: ProductEnvironment): string => {
	return `${getForgeSandboxOrigin(environment)}/runtime/sandbox.html`;
};

export const makeEncodedAppContext = (
	extension: GQLExtension,
	environment: ProductEnvironment,
): string => {
	return urlSafeB64(getEncodedAppContext(extension, undefined, environment));
};
